<script lang="ts">
	import { gdprPathMap } from "../../../../core/schema/paths/gdprPathMap.js";
	import Checkbox from "./Checkbox.svelte";
	import translations from "./GdprCheckbox.translations.json";
	import { getTranslate } from "../../utils/getTranslate.js";
	import { getTenant } from "../../getTenant.js";

	const translate = getTranslate(translations);

	const tenant = getTenant();

	let formControlClass = "";
	export { formControlClass as class };
	export let gdprApprovedAt: string | null = null;

	let input: HTMLInputElement | null = null;

	$: {
		if (input) {
			input.checked = Boolean(gdprApprovedAt);
		}
	}

	function checkedTerms(event: Event): void {
		const input = event.target as HTMLInputElement;
		gdprApprovedAt = input.checked ? new Date().toISOString() : null;
	}
</script>

<div class="relative">
	<Checkbox
		bind:input
		id="gdprApproved"
		name=""
		on:change={checkedTerms}
		required
		class={formControlClass}
		labelProps={{ class: "!text-xs lg:!text-base uppercase font-bahnschrift font-bold tracking-wider" }}
	>
		{translate("agree")}&nbsp;<a
			class="text-ltprimary-300 hover:text-ltprimary decoration-ltprimary-400 text- uppercase underline transition-[color,text-decoration] duration-200 ease-in-out hover:decoration-transparent"
			href="/{gdprPathMap[tenant.locale]}"
			target="_blank"
		>
			{translate("policy")}
		</a>
	</Checkbox>
	<input type="hidden" name="gdprApprovedAt" value={gdprApprovedAt ?? ""} />
</div>
